import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from '../baseTypes';
import { getSessionSuggestedCPTCodes } from '@uplift/api';


export const useSessionSuggestedCPTCodesQuery = (sessionId?: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'session', sessionId, 'cptSuggestions' ],
    queryFn: async () => {
      if (!sessionId) {
        return {};
      }

      const response = await getSessionSuggestedCPTCodes(sessionId);
      const suggestions = response.data?.reduce((prev, curr) => {
        if (prev[curr.code]) {
          return {
            ...prev,
            [curr.code]: {
              message: curr.reasoning,
              count: prev[curr.code].count + 1,
            }
          };
        }

        return {
          ...prev,
          [curr.code]: {
            message: curr.reasoning,
            count: 1,
          }
        };
      }, {} as Record<string, { message: string; count: number }>);

      // suggestions['90840'] = 'hello';
      // suggestions['96158'] = 'hello';

      return suggestions;
    },
    ...opts
  });
};
